import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ChronologyComponent } from './chronology/chronology.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    TranslateModule
  ],
  declarations: [
    ChronologyComponent,
  ],
  exports: [
    ChronologyComponent,
  ]
})
export class TimelineModule { }
